import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import { useEffect } from 'react'
import { useStore } from './store/useStore'

// Layout Components
import Navbar from './components/layout/Navbar'
import Footer from './components/layout/Footer'

// Pages
import Home from './pages/Home'
import Services from './pages/Services'
import About from './pages/About'
import Contact from './pages/Contact'
import Gallery from './pages/Gallery'
import Appointment from './pages/Appointment'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import JobDetails from './pages/JobDetails'

// Admin Pages
import AdminLogin from './pages/admin/Login'
import Dashboard from './pages/admin/Dashboard'
import JobManagement from './pages/admin/JobManagement'
import GalleryManagement from './pages/admin/GalleryManagement'
import ApplicationsManagement from './pages/admin/ApplicationsManagement'
import AdminManagement from './pages/admin/AdminManagement'
import MessagesManagement from './pages/admin/MessagesManagement'
import Settings from './pages/admin/Settings'
import DataManagement from './pages/admin/DataManagement'
import SocialMediaManagement from './pages/admin/SocialMediaManagement'
import AuthTest from './pages/admin/AuthTest'

// Auth Components
import ProtectedRoute from './components/auth/ProtectedRoute'

// Background Components
import AnimatedBackground from './components/background/AnimatedBackground'

// Compliance Components
import GDPRBanner from './components/compliance/GDPRBanner'

// Modals
import Modals from './components/modals'

// Job Banner
import JobBanner from './components/jobs/JobBanner'

function App() {
  const { checkAuth } = useStore()

  useEffect(() => {
    try {
      checkAuth()
    } catch (error) {
      console.error('Erreur lors de la vérification d\'authentification:', error)
    }
  }, [checkAuth])

  return (
    <Router>
        <div className="relative min-h-screen animated-gradient">
          <AnimatedBackground />
          
          <div className="relative z-10">
            <Navbar />
            
            <AnimatePresence mode="wait">
              <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/gallery" element={<Gallery />} />
                <Route path="/appointment" element={<Appointment />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/jobs/:id" element={<JobDetails />} />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/test" element={<AuthTest />} />
              <Route path="/admin" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin/jobs" element={
                <ProtectedRoute>
                  <JobManagement />
                </ProtectedRoute>
              } />
              <Route path="/admin/gallery" element={
                <ProtectedRoute>
                  <GalleryManagement />
                </ProtectedRoute>
              } />
              <Route path="/admin/applications" element={
                <ProtectedRoute>
                  <ApplicationsManagement />
                </ProtectedRoute>
              } />
              <Route path="/admin/admins" element={
                <ProtectedRoute>
                  <AdminManagement />
                </ProtectedRoute>
              } />
              <Route path="/admin/messages" element={
                <ProtectedRoute>
                  <MessagesManagement />
                </ProtectedRoute>
              } />
              <Route path="/admin/settings" element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              } />
              <Route path="/admin/data" element={
                <ProtectedRoute>
                  <DataManagement />
                </ProtectedRoute>
              } />
              <Route path="/admin/social" element={
                <ProtectedRoute>
                  <SocialMediaManagement />
                </ProtectedRoute>
              } />
              </Routes>
            </AnimatePresence>
            
            <Footer />
          </div>

          {/* Job Banner */}
          <JobBanner />

          {/* GDPR Banner */}
          <GDPRBanner />

          {/* Modals */}
          <Modals />
        </div>
      </Router>
    )
  }

export default App

